import { pick } from 'ramda';

export default pick([
  'autofocus',
  'cols',
  'dirname',
  'disabled',
  'form',
  'maxlength',
  'name',
  'placeholder',
  'readonly',
  'required',
  'rows',
  'wrap',
]);
